enum HousekeepingTaskType {
	None = "None",
	Towels = "Towels",
	Bedsheets = "Bedsheets",
	All = "All",
}

export default HousekeepingTaskType;